/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateOutputCommandResult } from '../../models/update-output-command-result';

export interface ApiMeetingsUpdateOutputPut$Plain$Params {
      body?: {
'Id'?: string;
'Output'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiMeetingsUpdateOutputPut$Plain(http: HttpClient, rootUrl: string, params?: ApiMeetingsUpdateOutputPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOutputCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsUpdateOutputPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateOutputCommandResult>;
    })
  );
}

apiMeetingsUpdateOutputPut$Plain.PATH = '/api/Meetings/UpdateOutput';
